class PDPConfiguration extends HTMLElement {
    constructor() {
        super();
  
        this.presetQuantities = this.querySelectorAll('input[name="preset-qty"]');
        this.attributeQuantity = this.querySelectorAll('.quantity__input');
        this.lensesOption = this.querySelectorAll('.lens_options');
        this.enableAttribute = this.querySelectorAll('.enable_attribute');
        this.quantityInput = document.querySelector('input.quantity__input[name="quantity"]');
        this.isPromo = this.getAttribute('data-is-promo') === 'true';

        // Also listen for ANY select or input changes within the component
        // This catches any lens options we might have missed
        this.addEventListener('change', (e) => {
            if (e.target.matches('select, input')) {
                // Debounce to avoid multiple updates
                clearTimeout(this.updateTimeout);
                this.updateTimeout = setTimeout(() => {
                    this.updateHiddenQuantity();
                }, 50);
            }
        });
        
        // Delay setting defaults to ensure all elements are present
        setTimeout(() => {
            this.setAllLensDefaults();
        }, 100);

        this.presetQuantities.forEach(radio => {
            radio.addEventListener('change', () => this.radioChanged(this, true));
        });

        // Update LensesOption Attribute
        this.lensesOption.forEach(select => {
            this.updatelensesAttribute(select);
            // IMPORTANT: Update total quantity when ANY lens option changes
            // This includes R-sterkte, L-sterkte, R-dia, L-dia, R-bc, L-bc
            select.addEventListener("change", () => {
                this.updatelensesAttribute(select);
                this.updateHiddenQuantity(); // Ensure quantity is updated
                //console.log(`Lens option changed: ${select.name || select.id}, updating quantity`);
            });
        });

        // Enable Lenses Attribute
        this.enableAttribute.forEach(input => {
            this.enableLensesAttribute(input);
            input.addEventListener("change", () => {
                this.enableLensesAttribute(input);
                this.updateHiddenQuantity(); // Add this line
            });
        });

        // Quantity input change handlers - Modified to sync both fields
        this.attributeQuantity.forEach(input => {
            input.addEventListener('change', (e) => this.syncQuantityFields(e.target));
            input.addEventListener('input', (e) => this.syncQuantityFields(e.target));
        });

        // Fire once on init
        this.radioChanged(this, true);
        this.rePositionElements();
        
        // Ensure lens selects are always enabled in promo mode
        if (this.isPromo) {
            this.ensureLensSelectsEnabled();
        }

        // Add form submission handler with better approach
        this.setupFormSubmission();
        
        // Ensure quantity is set on initialization
        this.updateHiddenQuantity();
        
        // Trigger price calculator update after initialization
        setTimeout(() => {
            if (window.PriceCalculator) {
                window.PriceCalculator.updateTotalPrice();
            }
        }, 200);
    }
  
    // New method to update the hidden quantity input
    updateHiddenQuantity() {
        const rechtsInput = this.querySelector('input[name="rechts_qty"]');
        const linksInput = this.querySelector('input[name="links_qty"]');
        
        // Calculate total quantity
        const rechtsQty = parseInt(rechtsInput?.value || 0);
        const linksQty = parseInt(linksInput?.value || 0);
        //const totalQty = rechtsQty + linksQty;
        const totalQty = rechtsQty;
        
        // Update the hidden quantity input
        if (this.quantityInput) {
            this.quantityInput.value = totalQty;
            //console.log('Updated hidden quantity to:', totalQty);
        }
        
        // Update total price if calculator exists
        if (window.PriceCalculator) {
            window.PriceCalculator.updateTotalPrice();
        }
    }
  
    // New method to synchronize quantity fields
    syncQuantityFields(changedInput) {
        const newValue = changedInput.value;
        const rechtsInput = this.querySelector('input[name="rechts_qty"]');
        const linksInput = this.querySelector('input[name="links_qty"]');
        
        // Update both fields to have the same value
        if (rechtsInput) rechtsInput.value = newValue;
        if (linksInput) linksInput.value = newValue;
        
        // Call the original quantity change handler
        this.quantityChange(changedInput, false);
        
        // Always update the hidden quantity
        this.updateHiddenQuantity();
        
        // Update total price if calculator exists
        if (window.PriceCalculator) {
            window.PriceCalculator.updateTotalPrice();
        }
    }

    setAllLensDefaults() {
        // For each select, set the corresponding hidden input to its value (default on load)
        this.lensesOption.forEach(select => {
            this.updatelensesAttribute(select);
        });
        // Also ensure both quantities are set on load
        const rechtsInput = this.querySelector('input[name="rechts_qty"]');
        const linksInput = this.querySelector('input[name="links_qty"]');
        if (rechtsInput) this.quantityChange(rechtsInput, false);
        if (linksInput) this.quantityChange(linksInput, false);
        
        // Ensure hidden quantity is updated
        this.updateHiddenQuantity();
    }

    radioChanged(element, isRadio) {
        const checked = element.querySelector('input[name="preset-qty"]:checked');
        if (!checked) return;

        const value = checked.value;
        const price_update = checked.getAttribute('data-discount-price');
        const priceID = element.getAttribute('data-price');
        const priceElement = document.getElementById(priceID);
        const priceItem = priceElement?.querySelector('.price-item--regular');
        
        if (priceItem) {
            priceItem.innerHTML = price_update;
        }

        // Set both eyes to the preset value
        this.attributeQuantity.forEach(input => {
            input.value = value;
            // Dispatch change event
            const event = new Event('change', { bubbles: true });
            input.dispatchEvent(event);
        });

        // Set the main quantity input to double the preset value
        if (this.quantityInput) {
            this.quantityInput.value = value * 2;
        }

        // Update total price if calculator exists
        if (window.PriceCalculator) {
            window.PriceCalculator.updateTotalPrice();
        }

        // Ensure the hidden total quantity input is updated
        this.quantityChange();
        this.updateHiddenQuantity();
    }

    rePositionElements() {
        // Move the append-to-form div inside the form
        let productForm = document.querySelector("product-form form");
        let appendToFormDiv = this.querySelector(".append-to-form");

        if (productForm && appendToFormDiv) {
            appendToFormDiv.style.display = 'none';
            // Remove any existing append-to-form divs to prevent duplication
            const existingAppendDivs = productForm.querySelectorAll('.append-to-form');
            existingAppendDivs.forEach(div => div.remove());
            
            // Append the new div
            productForm.appendChild(appendToFormDiv);
        }
    }

    quantityChange(element, isRadio) {
        if (!element) return;

        // Get the current values from the visible inputs
        const rechtsInput = this.querySelector('input[name="rechts_qty"]');
        const linksInput = this.querySelector('input[name="links_qty"]');

        // Calculate total quantity
        const rechtsQty = parseInt(rechtsInput?.value || 0);
        const linksQty = parseInt(linksInput?.value || 0);
        const totalQty = rechtsQty + linksQty;

        //console.log(totalQty);

        // Update the hidden quantity input
        if (this.quantityInput) {
            this.quantityInput.value = totalQty;
        }

        // Update total price if calculator exists
        if (window.PriceCalculator) {
            window.PriceCalculator.updateTotalPrice();
        }
    }

    updatelensesAttribute(select) {
        let targetId = select.getAttribute("data-target");
        let targetInput = document.getElementById(targetId);
        
        if (targetInput) {
            targetInput.value = select.value;
        }
        
        // IMPORTANT: Always update quantity when ANY lens attribute changes
        // This ensures R-dia, L-dia, R-bc, L-bc changes also update quantity
        this.updateHiddenQuantity();
        
        // Update total price if calculator exists
        if (window.PriceCalculator) {
            window.PriceCalculator.updateTotalPrice();
        }
        
        // Log for debugging
        const selectName = select.name || select.className || targetId;
        //console.log(`Updated lens attribute: ${selectName} = ${select.value}, recalculating quantity`);
    }

    enableLensesAttribute(input) {
        const retchsItems = document.querySelectorAll('.rechts');
        const linksItems = document.querySelectorAll('.links');
        
        if (input.checked) {
            // Fire once on init
            this.radioChanged(this, false);
            
            if (input.name === "enable_rechts") {
                retchsItems.forEach(retchs => {
                    let select = retchs.querySelector('select');
                    retchs.classList.remove('disabled');
                    if (select) {
                        select.removeAttribute('disabled');
                    }
                });
            } else {
                linksItems.forEach(links => {
                    let select = links.querySelector('select');
                    links.classList.remove('disabled');
                    if (select) {
                        select.removeAttribute('disabled');
                    }
                });
            }
        } else {
            if (input.name === "enable_rechts") {
                if (this.quantityInput) {
                    this.quantityInput.value = 0;
                }
                // Don't disable lens selects in promo mode
                if (!this.isPromo) {
                    retchsItems.forEach(retchs => {
                        let select = retchs.querySelector('select');
                        retchs.classList.add('disabled');
                        if (select) {
                            select.setAttribute('disabled','disabled');
                        }
                    });
                }
            } else {
                if (this.quantityInput) {
                    this.quantityInput.value = 0;
                }
                // Don't disable lens selects in promo mode
                if (!this.isPromo) {
                    linksItems.forEach(links => {
                        let select = links.querySelector('select');
                        links.classList.add('disabled');
                        if (select) {
                            select.setAttribute('disabled','disabled');
                        }
                    });
                }
            }
        }

        // Update total price if calculator exists
        if (window.PriceCalculator) {
            window.PriceCalculator.updateTotalPrice();
        }
        
        // Always update hidden quantity
        this.updateHiddenQuantity();
    }

    ensureLensSelectsEnabled() {
        const retchsItems = document.querySelectorAll('.rechts');
        const linksItems = document.querySelectorAll('.links');
        
        [...retchsItems, ...linksItems].forEach(item => {
            let select = item.querySelector('select');
            item.classList.remove('disabled');
            if (select) {
                select.removeAttribute('disabled');
            }
        });
    }

    setupFormSubmission() {
      // 2. Also listen for click on submit buttons
      const submitButtons = document.querySelector('button[name="add"]');
      const rechtsInput = this.querySelector('input[name="rechts_qty"]');
      const linksInput = this.querySelector('input[name="links_qty"]');
      
      submitButtons.addEventListener('click', (e) => {
        console.log("submit button clicked");
        setTimeout(() => {
        linksInput.value = 1;
        rechtsInput.value = 1;
        }, 900);
      }, true);
    }

    handleFormSubmission(form) {
        // Get quantities from both inputs
        const rechtsInput = this.querySelector('input[name="rechts_qty"]');
        const linksInput = this.querySelector('input[name="links_qty"]');
        
        // Calculate total quantity
        const rechtsQty = parseInt(rechtsInput?.value || 0);
        const linksQty = parseInt(linksInput?.value || 0);
        const totalQty = rechtsQty + linksQty;

        // Update the hidden quantity input
        if (this.quantityInput) {
            this.quantityInput.value = totalQty;
            //console.log('Form submission - setting quantity to:', totalQty);
        }
        // Submit the form
        form.submit();
    }
}

customElements.define('pdp-configuration', PDPConfiguration);

//   custom price script
// Production Price Calculator
// Updated for synchronized quantity fields

(function() {
  'use strict';
  
  // Configuration
  const CONFIG = {
    selectors: {
      priceElement: '.price__container .price-item.price-item--regular',
      rechtsCheckbox: '#enable_rechts',
      linksCheckbox: '#enable_links',
      rechtsQtyInput: 'input[name="rechts_qty"]',
      linksQtyInput: 'input[name="links_qty"]',
      quantityButtons: '.quantity__button',
      totalPriceContainer: '.total-price',
      totalPriceStrong: '.total-price strong',
      quantityInputs: '.quantity__input'
    },
    styles: {
      fontWeight: 'bold',
      fontSize: '1.2em',
      marginTop: '10px',
      padding: '8px',
      backgroundColor: '#f8f9fa',
      border: '1px solid #dee2e6',
      borderRadius: '4px'
    }
  };
  
  let elements = {};
  let totalPriceElement = null;
  let priceObserver = null;
  
  // Initialize the price calculator
  function init() {
    try {
      //console.log('Price Calculator - Initializing...');
      findElements();
      createTotalPriceElement();
      attachEventListeners();
      setupPriceObserver();
      addQuantityButtonHandling();
      updateTotalPrice();
      //console.log('Price Calculator - Initialization complete');
    } catch (error) {
      console.error('Price Calculator initialization failed:', error);
    }
  }
  
  // Find and cache DOM elements
  function findElements() {
    //console.log('findElements called with selectors:', CONFIG.selectors);
    
    // Check for multiple elements with the same selectors
    const allRechtsCheckboxes = document.querySelectorAll(CONFIG.selectors.rechtsCheckbox);
    const allLinksCheckboxes = document.querySelectorAll(CONFIG.selectors.linksCheckbox);
    const allRechtsQtyInputs = document.querySelectorAll(CONFIG.selectors.rechtsQtyInput);
    const allLinksQtyInputs = document.querySelectorAll(CONFIG.selectors.linksQtyInput);
    
    // console.log('All elements found with selectors:', {
    //   rechtsCheckboxes: allRechtsCheckboxes.length,
    //   linksCheckboxes: allLinksCheckboxes.length,
    //   rechtsQtyInputs: allRechtsQtyInputs.length,
    //   linksQtyInputs: allLinksQtyInputs.length
    // });
    
    elements = {
      price: document.querySelector(CONFIG.selectors.priceElement),
      rechtsCheckbox: document.querySelector(CONFIG.selectors.rechtsCheckbox),
      linksCheckbox: document.querySelector(CONFIG.selectors.linksCheckbox),
      rechtsQtyInput: document.querySelector(CONFIG.selectors.rechtsQtyInput),
      linksQtyInput: document.querySelector(CONFIG.selectors.linksQtyInput),
      quantityButtons: document.querySelectorAll(CONFIG.selectors.quantityButtons),
      quantityInputs: document.querySelectorAll(CONFIG.selectors.quantityInputs)
    };
    
    // Debug logging to see what elements are found
    // console.log('Price Calculator - Elements found:', {
    //   price: !!elements.price,
    //   rechtsCheckbox: !!elements.rechtsCheckbox,
    //   linksCheckbox: !!elements.linksCheckbox,
    //   rechtsQtyInput: !!elements.rechtsQtyInput,
    //   linksQtyInput: !!elements.linksQtyInput,
    //   quantityButtons: elements.quantityButtons.length,
    //   quantityInputs: elements.quantityInputs.length
    // });
    
    // Log the actual elements found
    // console.log('Actual elements found:', {
    //   price: elements.price,
    //   rechtsCheckbox: elements.rechtsCheckbox,
    //   linksCheckbox: elements.linksCheckbox,
    //   rechtsQtyInput: elements.rechtsQtyInput,
    //   linksQtyInput: elements.linksQtyInput
    // });
    
    // Validate required elements
    if (!elements.price) {
      console.warn('Price element not found. Calculator may not work properly.');
    }
  }
  
  // Create or find total price display element
  function createTotalPriceElement() {
    totalPriceElement = document.querySelector(CONFIG.selectors.totalPriceContainer);
    
    // Debug logging
    // console.log('Price Calculator - Total price element found:', !!totalPriceElement);
    // if (totalPriceElement) {
    //   console.log('Total price element HTML:', totalPriceElement.innerHTML);
    // }
    
    // The .total-price div should already exist in your Liquid template
    // We don't create it, just find it and use it
    if (!totalPriceElement) {
      console.warn('.total-price element not found. Make sure your Liquid template includes the total-price div.');
    }
  }
  
  // Extract price from text with proper decimal handling
  function extractPrice(priceText) {
    if (!priceText) return 0;
    
    // Remove currency symbols and whitespace
    let cleanPrice = priceText.replace(/[€$£\s]/g, '');
    
    // Handle European number format (comma as decimal separator)
    const commaIndex = cleanPrice.lastIndexOf(',');
    const dotIndex = cleanPrice.lastIndexOf('.');
    
    if (commaIndex > -1 && (cleanPrice.length - commaIndex) <= 3) {
      // Comma is likely decimal separator
      cleanPrice = cleanPrice.replace(/\./g, '').replace(',', '.');
    } else if (dotIndex > -1 && (cleanPrice.length - dotIndex) <= 3) {
      // Dot is likely decimal separator, remove any commas (thousands separators)
      cleanPrice = cleanPrice.replace(/,/g, '');
    }
    
    const price = parseFloat(cleanPrice);
    return isNaN(price) ? 0 : price;
  }
  
  // Synchronize quantity fields when buttons are clicked
  function syncQuantityFields(changedInput) {
    const newValue = changedInput.value;
    const rechtsInput = document.querySelector('input[name="rechts_qty"]');
    const linksInput = document.querySelector('input[name="links_qty"]');
    
    // Update both fields to have the same value
    if (rechtsInput && linksInput) {
      rechtsInput.value = newValue;
      linksInput.value = newValue;
    }
  }
  
  // Add quantity button handling specifically for non-promo products
  function addQuantityButtonHandling() {
    // Check if this is a non-promo product
    const pdpConfig = document.querySelector('pdp-configuration');
    const isPromo = pdpConfig && pdpConfig.getAttribute('data-is-promo') === 'true';
    
    if (!isPromo) {
      // Find all quantity buttons that are NOT managed by Alpine.js
      const quantityButtons = document.querySelectorAll('.quantity__button:not([\\@click]):not([\\@click\\.prevent])');
      
      quantityButtons.forEach(button => {
        // Remove any existing click handlers to avoid conflicts
        const newButton = button.cloneNode(true);
        button.parentNode.replaceChild(newButton, button);
        
        // Add our click handler
        newButton.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopImmediatePropagation();
          
          const quantityInput = this.closest('quantity-input').querySelector('.quantity__input');
          const buttonName = this.getAttribute('name');
          const currentValue = parseInt(quantityInput.value) || 1;
          
          if (buttonName === 'plus') {
            quantityInput.value = currentValue + 1;
          } else if (buttonName === 'minus' && currentValue > 1) {
            quantityInput.value = currentValue - 1;
          }
          
          // Update button states
          updateButtonStates(quantityInput);
          
          // Trigger change event for PDPConfiguration to handle
          const event = new Event('change', { bubbles: true });
          quantityInput.dispatchEvent(event);
          
          // Update total price
          updateTotalPrice();
        });
      });
    }
  }
  
  // Update button states (enable/disable minus button)
  function updateButtonStates(input) {
    const quantityContainer = input.closest('quantity-input');
    const minusButton = quantityContainer.querySelector('button[name="minus"]');
    const currentValue = parseInt(input.value) || 1;
    
    if (minusButton) {
      if (currentValue <= 1) {
        minusButton.classList.add('disabled');
        minusButton.disabled = true;
      } else {
        minusButton.classList.remove('disabled');
        minusButton.disabled = false;
      }
    }
  }
  
  // Calculate and update total price
  function updateTotalPrice() {
    //console.log('updateTotalPrice called');
    if (!elements.price || !totalPriceElement) return;
    
    try {
      // Get current base price
      const basePrice = extractPrice(elements.price.textContent || elements.price.innerText);
      
      // For promo version, checkboxes are always checked, so just get quantities directly
      const rechtsQty = Math.max(0, parseInt(elements.rechtsQtyInput?.value || 0));
      const linksQty = Math.max(0, parseInt(elements.linksQtyInput?.value || 0));
      
      // Calculate totals
      const totalQuantity = rechtsQty + linksQty;
      const totalPrice = basePrice * totalQuantity;
      
      // Debug logging
      //console.log(`Price calculation: Base: €${basePrice}, Rechts: ${rechtsQty}, Links: ${linksQty}, Total: €${totalPrice}`);
      
      // Additional debugging to see what elements are found
      // console.log('Elements debug:', {
      //   price: elements.price?.textContent,
      //   rechtsQtyInput: elements.rechtsQtyInput?.value,
      //   linksQtyInput: elements.linksQtyInput?.value
      // });
      
      // More detailed debugging
      // console.log('Detailed element info:', {
      //   rechtsQtyInputElement: elements.rechtsQtyInput,
      //   linksQtyInputElement: elements.linksQtyInput,
      //   rechtsQtyValue: elements.rechtsQtyInput?.value,
      //   linksQtyValue: elements.linksQtyInput?.value
      // });
      
      // Update display
      updateTotalPriceDisplay(basePrice, totalQuantity, totalPrice);
      
    } catch (error) {
      console.error('Error updating total price:', error);
      totalPriceElement.innerHTML = '<strong>Error calculating price</strong>';
    }
  }
  
  // Update the total price display
  function updateTotalPriceDisplay(basePrice, totalQuantity, totalPrice) {
    // Find the <strong> element inside the total-price div
    const strongElement = totalPriceElement.querySelector('strong');
    
    // console.log('updateTotalPriceDisplay called:', {
    //   totalPriceElement: !!totalPriceElement,
    //   strongElement: !!strongElement,
    //   totalQuantity,
    //   totalPrice
    // });
    
    if (strongElement) {
      // Only update the price value inside <strong>, keeping Liquid template text intact
      if (totalQuantity > 0) {
        strongElement.textContent = `€${totalPrice.toFixed(2)}`;
        //console.log('Updated strong element to:', `€${totalPrice.toFixed(2)}`);
      } else {
        strongElement.textContent = '€0.00';
        //console.log('Updated strong element to: €0.00');
      }
    } else {
      // Fallback: if no <strong> element found, log warning
      console.warn('Strong element not found in .total-price div. Cannot update total price.');
    }
  }
  
  // Attach all event listeners
  function attachEventListeners() {
    // Checkbox change events
    if (elements.rechtsCheckbox) {
      elements.rechtsCheckbox.addEventListener('change', updateTotalPrice);
    }
    
    if (elements.linksCheckbox) {
      elements.linksCheckbox.addEventListener('change', updateTotalPrice);
    }
    
    // Quantity input events - each field can be changed independently
    if (elements.rechtsQtyInput) {
      elements.rechtsQtyInput.addEventListener('input', updateTotalPrice);
      elements.rechtsQtyInput.addEventListener('change', updateTotalPrice);
    }
    
    if (elements.linksQtyInput) {
      elements.linksQtyInput.addEventListener('input', updateTotalPrice);
      elements.linksQtyInput.addEventListener('change', updateTotalPrice);
    }
    
    // Initialize button states for all quantity inputs
    elements.quantityInputs.forEach(input => {
      updateButtonStates(input);
      
      input.addEventListener('input', function() {
        updateButtonStates(this);
      });
      
      input.addEventListener('change', function() {
        updateButtonStates(this);
      });
    });
  }
  
  // Setup price change observer for bulk discounts
  function setupPriceObserver() {
    if (!elements.price || !window.MutationObserver) return;
    
    priceObserver = new MutationObserver(function(mutations) {
      let shouldUpdate = false;
      
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList' || mutation.type === 'characterData') {
          shouldUpdate = true;
        }
      });
      
      if (shouldUpdate) {
        updateTotalPrice();
      }
    });
    
    priceObserver.observe(elements.price, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }
  
  // Cleanup function
  function destroy() {
    if (priceObserver) {
      priceObserver.disconnect();
      priceObserver = null;
    }
    
    // Remove event listeners would require keeping references
    // For production, this is typically not needed unless dynamically removing
  }
  
  // Auto-initialize when DOM is ready
  function autoInit() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      // DOM already loaded
      setTimeout(init, 100); // Small delay to ensure all elements are rendered
    }
  }
  
  // Public API (if needed)
  window.PriceCalculator = {
    init: init,
    destroy: destroy,
    updateTotalPrice: updateTotalPrice,
    version: '1.3.0'
  };
  
  // Auto-start
  autoInit();
  
})();
